<!------------------------------

      Page Actions

------------------------------->

<ng-container *sbPageAction>
  <button
    *ngPermissions="permissionService.Permission.player_software_create"
    type="button"
    sb-button-primary
    [color]="'green'"
    [icon]="'plus'"
    [loading]="loading()"
    [iconButton]="true"
    [sbRouterLink]="util.RoutingID.deviceSoftwareCreate"
    [queryParams]="{returnTo: util.getPageLink()}"
    sbTooltip="{{ 'lang.devices.createDeviceSoftware' | translate }}"
  >
  </button>

  <button
    type="button"
    sb-button-primary
    color="blue"
    sbTooltip="{{ 'lang.globals.refresh' | translate }}" placement="top"
    container="body"
    [iconButton]="true"
    [icon]="'refresh'"
    (click)="requestDebounced()"
    [disabled]="loading()"
    [loading]="loading()">
  </button>

</ng-container>

<!------------------------------

  Table Wrapper

------------------------------->

<sb-table-wrapper-new
  headline="{{'lang.globals.playerSoftware' | translate}}"
  [itemsData]="playerSoftware"
  (paginationChange)="requestDebounced($event)"
  [loading]="loading()"
  [itemName]="'playerSoftware'">

  <!------------------------------

  Filter Panel

------------------------------->

  <div filter-panel class="tw-bg-[#F8F9FC] dark:tw-bg-sbGray-930 tw-rounded-l-xl">
    <sb-filter-panel
      (filterChange)="applyFiltering($event)"
      [headerClasses]="'tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-border-solid tw-border-0 tw-z-40 tw-border-b tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-h-[60px] tw-rounded-tl-xl'"
      [config]="filterConfig"
    >

    </sb-filter-panel>
  </div>

  <!------------------------------

    Table Header

------------------------------->

  <ng-template #thead>
    <tr>
      <th>ID</th>
      <th>{{ 'lang.globals.name' | translate }}</th>
      <th>{{ 'lang.globals.description' | translate }}</th>
      <th>{{ 'lang.devices.editDeviceSoftware.os' | translate }}</th>
      <th>{{ 'lang.devices.editDeviceSoftware.version' | translate }}</th>
      <th>{{ 'lang.devices.editDeviceSoftware.protocol' | translate }}</th>
      <th class="sticky-col last-col tw-z-20">
        {{ 'lang.globals.action' | translate }}
      </th>
    </tr>
  </ng-template>

  <ng-template #tCardHead>
    <tr>
      <th class="table--sortable">ID</th>
      <th class="table--sortable">{{ 'lang.globals.name' | translate }}</th>
      <th class="table--sortable">{{ 'lang.globals.description' | translate }}</th>
      <th class="table--sortable">{{ 'lang.devices.editDeviceSoftware.os' | translate }}</th>
      <th class="table--sortable">{{ 'lang.devices.editDeviceSoftware.version' | translate }}</th>
      <th class="table--sortable">{{ 'lang.devices.editDeviceSoftware.protocol' | translate }}</th>
      <th class="!tw-w-auto"><!-- empty header for minimal header with on the others --></th>
    </tr>
  </ng-template>

  <!------------------------------

  Table Body

------------------------------->

  <ng-template #tbody let-player>
    <tr>
      <td>{{ player.id }}</td>
      <td>
        <sb-comp-link
          [title]="player.name"
          [condition]="!player.global"
          [link]="util.RoutingID.deviceSoftwareEdit"
          [permission]="permissionService.Permission.player_software_edit"
          [queryParams]="{returnTo: util.getPageLink()}"
          [pathParams]="[{id: 'playerSoftwareID', value: player?.id }]"
          [tooltip]="'lang.globals.edit' | translate">
        </sb-comp-link>
      </td>
      <td>
        <span [innerHTML]="player.description | truncate : 50"></span>
      </td>
      <td>{{ player.os }}</td>
      <td>{{ player.version }}</td>
      <td>{{ player.protocol }}</td>
      <td class="tr bw sticky-col last-col">
        <sb-split-button
          [splitButtonItems]="player.sbButtons ?? []"
          (selectedAction)="resolveSplitButtonAction(player, $event)"
        ></sb-split-button>
      </td>
    </tr>
  </ng-template>

  <!------------------------------

       Card Element

   ------------------------------->

  <ng-template #card let-player>
    <sb-table-card class="tw-rounded-xl">
      <div table-card-header class="tw-flex tw-gap-3">
      </div>
      <div table-card-header-more>
        <sb-split-button
          [splitButtonItems]="player.sbButtons ?? []"
          (selectedAction)="resolveSplitButtonAction(player, $event)"
        ></sb-split-button>
      </div>
      <div table-card-img>
        <div class="tw-bg-[url(assets/img/devicedetails-bg.jpg)] tw-bg-cover tw-bg-center tw-h-full">
        </div>
      </div>
      <div table-card-body>
        <div
          class="sm:tw-grid sm:tw-grid-cols-4 tw-flex tw-flex-col tw-text-sbGray-800 *:sm:tw-col-span-2 *:tw-w-full *:tw-border-0 *:tw-border-b *:tw-border-solid *:tw-border-sbGray-200 *:tw-py-3.5 *:sm:tw-py-5">
          <sb-table-card-element
            [orientation]="'left'" [headline]="'lang.globals.id' | translate">
            <sb-comp-name-wrapper>
              <span firstLine>{{ player.id }}</span>
            </sb-comp-name-wrapper>
          </sb-table-card-element>
          <sb-table-card-element [headline]="'lang.globals.name' | translate " [orientation]="'right'"
                                 [classes]="'tw-gap-2'">
            <sb-comp-link
              [title]="player.name"
              [condition]="!player.global"
              [link]="util.RoutingID.deviceSoftwareEdit"
              [permission]="permissionService.Permission.player_software_edit"
              [queryParams]="{returnTo: util.getPageLink()}"
              [pathParams]="[{id: 'playerSoftwareID', value: player?.id }]"
              [tooltip]="'lang.globals.edit' | translate">
            </sb-comp-link>
          </sb-table-card-element>
          <sb-table-card-element class="!tw-col-span-4" [headline]="'lang.globals.description' | translate " [orientation]="'left'"
                                 [classes]="'tw-gap-2'">
            <span [innerHTML]="player?.description ? (player?.description | truncate : 50) : '-'"></span>
          </sb-table-card-element>
          <sb-table-card-element [headline]="'lang.devices.editDeviceSoftware.os' | translate " [orientation]="'left'"
                                 [classes]="'tw-gap-2'">
            <span>{{ player?.os ? player.os : '-' }}</span>
          </sb-table-card-element>
          <sb-table-card-element [headline]="'lang.devices.editDeviceSoftware.version' | translate " [orientation]="'right'"
                                 [classes]="'tw-gap-2'">
            <span>{{ player?.version ? player.version : '-' }}</span>
          </sb-table-card-element>
          <sb-table-card-element class="!tw-col-span-4" class="!tw-border-0"
                                 [headline]="'lang.devices.editDeviceSoftware.protocol' | translate " [orientation]="'left'"
                                 [classes]="'tw-gap-2'">
            <span>{{ player?.protocol ? player.protocol : '-' }}</span>
          </sb-table-card-element>
        </div>
      </div>
    </sb-table-card>
  </ng-template>

</sb-table-wrapper-new>
